import { render, staticRenderFns } from "./MFAVerificationModal.vue?vue&type=template&id=40ff5e0a&scoped=true"
import script from "./MFAVerificationModal.vue?vue&type=script&lang=ts"
export * from "./MFAVerificationModal.vue?vue&type=script&lang=ts"
import style0 from "./MFAVerificationModal.vue?vue&type=style&index=0&id=40ff5e0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ff5e0a",
  null
  
)

export default component.exports